import trackEvent from '@99designs/utils/platform/trackEvent';

const emailsubscriptionEndpoint = '/campaigns/xhr/email-subscriptions';

export default class EmailSubscriptionService {
    subscribe({email, acquisition_source, custom_data = {}, email_capture_name = null}) {
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            const payload = {
                'email_address': email,
                'acquisition_source': acquisition_source,
                'custom_data': custom_data,
            }

            if (window.trackParams) {
                payload['extra_event_properties'] = Object.assign({email_capture_name}, window.trackParams);
            }

            req.open('POST', emailsubscriptionEndpoint);
            req.setRequestHeader('Content-Type', 'application/json');
            req.onload = () => {
                if (req.status === 200) {
                    this.trackSuccess({email, acquisition_source, email_capture_name})
                    resolve(JSON.parse(req.response));
                } else {
                    reject(JSON.parse(req.response));
                }
            }

            req.onerror = (e) => {
                reject(Error(`Error: ${e}`));
            }

            req.send(JSON.stringify({'email_subscription': payload}));
        });
    }

    trackSuccess({email, acquisition_source, email_capture_name = null}) {
        trackEvent('Completed Email Subscription', {
            'email_address': email,
            'acquisition_source': acquisition_source,
            'email_capture_name': email_capture_name,
        });
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/email-subscription-service/src/EmailSubscriptionService.js